// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    var search = params;
    search.params = {};
    console.log(dateRange);
    console.log(propName);
    if (null != dateRange && "" != dateRange) {
        if (typeof propName === "undefined") {
            search.params["beginTime"] = dateRange[0];
            search.params["endTime"] = dateRange[1];
        } else {
            search.params[propName + "BeginTime"] = dateRange[0];
            search.params[propName + "EndTime"] = dateRange[1];
        }
    }

    return search;
}

// 添加金额/日期范围
export function money(params, dateRange, propName, iHourseStatus) {
    var search = params;
    search.params = {};
    if (null != dateRange && "" != dateRange) {
        search.params["moneyMin"] = dateRange.moneyMin;
        search.params["moneyMax"] = dateRange.moneyMax;
    }
    if (null != propName && "" != propName) {
        search.params["beginTime"] = propName[0];
        search.params["endTime"] = propName[1];
    }
    if (null != iHourseStatus && "" != iHourseStatus) {
        search.params["iHourseStatus"] = iHourseStatus;
    }
    search.params.correlation = false
    console.warn(search)
    return search;
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
    id = id || "id";
    parentId = parentId || "parentId";
    children = children || "children";
    rootId =
        rootId ||
        Math.min.apply(
            Math,
            data.map(item => {
                return item[parentId];
            })
        ) ||
        0;

    //对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data));
    //循环所有项
    const treeData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => {
            //返回每一项的子级数组
            return father[id] === child[parentId];
        });
        branchArr.length > 0 ? (father.children = branchArr) : "";
        //返回第一层
        return father[parentId] === rootId;
    });

    return treeData != "" ? treeData : data;
}

export function handleTreeOther(data, id, vFatherId, children, rootId) {
    id = id || "id";
    vFatherId = vFatherId || "vFatherId";
    children = children || "children";
    rootId =
        rootId ||
        Math.min.apply(
            Math,
            data.map(item => {
                return item[vFatherId];
            })
        ) ||
        0;

    //对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data));
    //循环所有项
    const treeData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => {
            //返回每一项的子级数组
            return father[id] === child[vFatherId];
        });
        branchArr.length > 0 ? (father.children = branchArr) : "";
        //返回第一层
        return father[vFatherId] === rootId;
    });
    return treeData != "" ? treeData : data;
}

// 防抖
export function Debounce(fn, delay) {
    var delay = delay || 200;
    var timer;
    return function () {
        var th = this;
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn.apply(th, args);
        }, delay);
    };
}
